var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrintingService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2621_10203)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 31,
    fill: "#00C67F",
    fillOpacity: 0.11
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3125 44.4595H55.9732C55.8259 44.4595 55.7054 44.5801 55.7054 44.7274V46.0667C55.7054 46.214 55.8259 46.3345 55.9732 46.3345H57.3125C57.4598 46.3345 57.5804 46.214 57.5804 46.0667V44.7274C57.5804 44.5801 57.4598 44.4595 57.3125 44.4595ZM58.3839 40.9774H54.3661V33.8792C54.3661 33.7319 54.2455 33.6113 54.0982 33.6113H39.9018C39.7545 33.6113 39.6339 33.7319 39.6339 33.8792V40.9774H35.6161C34.1362 40.9774 32.9375 42.1761 32.9375 43.656V54.6381C32.9375 55.2307 33.4163 55.7095 34.0089 55.7095H39.6339V60.1292C39.6339 60.2765 39.7545 60.397 39.9018 60.397H54.0982C54.2455 60.397 54.3661 60.2765 54.3661 60.1292V55.7095H59.9911C60.5837 55.7095 61.0625 55.2307 61.0625 54.6381V43.656C61.0625 42.1761 59.8638 40.9774 58.3839 40.9774ZM41.9107 35.8881H52.0893V40.9774H41.9107V35.8881ZM52.0893 58.1203H41.9107V48.8792H52.0893V58.1203ZM58.7857 53.4328H54.3661V46.6024H39.6339V53.4328H35.2143V43.656C35.2143 43.435 35.3951 43.2542 35.6161 43.2542H58.3839C58.6049 43.2542 58.7857 43.435 58.7857 43.656V53.4328Z",
    fill: "#20435D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2621_10203",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_2621_10203"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintingService);
export default __webpack_public_path__ + "static/media/printing-service.569d1fd02e6f33c843a819bb2209c3e7.svg";
export { ForwardRef as ReactComponent };